<div class="d-flex flex-row align-items-center justify-content-center m-auto">
  <div class="row justify-content-center text-justify text-center">
    <!-- <div class="row">
      <div class="contact-text m-2">Help is available right now!</div>
    </div> -->

    <div class="row">
      <div class="contact-text m-2">
        If this is an emergency call 911 or UT Police Department (<i
          class="dx-icon-tel icon-phone"
        ></i>
        <a class="contact-number" href="tel:+17137927867"
          ><span>713&#8209;792&#8209;7867</span></a
        >)
      </div>
    </div>
    <div class="row">
      <a
        class="contact-text"
        href="https://mdandersonorg.sharepoint.com/sites/employee-assistance-program"
        (click)="onClick('EPA','https://mdandersonorg.sharepoint.com/sites/employee-assistance-program')"
        target="_blank"
      >
        <span>Employee Assistance Program</span>
        <i class="icon-share-link"></i>
      </a>
    </div>
    <div class="row">
      <h4>
        <i class="dx-icon-tel icon-phone"></i>
        <a
          class="contact-number"
          href="tel:+17137456901"
          (click)="onClick('EPA-Phone','713-745-6901')"
        >
          <span>713&#8209;745&#8209;6901</span>
        </a>
      </h4>
    </div>

    <div class="row">
      <a
        class="contact-text"
        href="https://988lifeline.org/current-events/the-lifeline-and-988/"
        (click)="onClick('NSPL','https://988lifeline.org/current-events/the-lifeline-and-988/')"
        target="_blank"
      >
        <span>National Suicide Prevention Lifeline</span>
        <i class="icon-share-link"></i>
      </a>
    </div>
    <div class="row">
      <h4>
        <i class="dx-icon-tel icon-phone"></i>
        <a
          class="contact-number"
          href="tel:+1988"
          (click)="onClick('NSPL-Phone','988')"
        >
          <span>988</span>
        </a>
      </h4>
    </div>

    <div class="row">
      <a
        class="contact-text"
        href="https://suicidepreventionlifeline.org/"
        (click)="onClick('NSH','https://suicidepreventionlifeline.org')"
        target="_blank"
      >
        <span>National Suicide Hotline</span>
        <i class="icon-share-link"></i>
      </a>
    </div>
    <div class="row">
      <h4>
        <i class="dx-icon-tel icon-phone"></i>
        <a
          class="contact-number"
          href="tel:+18002738255"
          (click)="onClick('NSH-Phone','1-800-273-8255')"
        >
          <span>1&#8209;800&#8209;273&#8209;8255</span>
        </a>
      </h4>
    </div>
    <div class="row">
      <a
        class="contact-text"
        href="https://www.crisishotline.org/"
        (click)="onClick('HIC','https://www.crisishotline.org')"
        target="_blank"
      >
        <span>Houston Crisis Intervention</span>
        <i class="icon-share-link"></i>
      </a>
    </div>
    <div class="row">
      <h4>
        <i class="dx-icon-tel icon-phone"></i>
        <a
          class="contact-number"
          href="tel:+18324161177"
          (click)="onClick('HIC-Phone','832-416-1177')"
        >
          <span>832&#8209;416&#8209;1177</span>
        </a>
      </h4>
    </div>
  </div>
</div>
